import { useGeoDataMyIp } from '@/hooks/useGeoDataMyIp';

import { isNearOneWayCity } from './oneWayCities';

// The homepage one-way banner shows only when the visitor's IP geolocates
// within ~50 miles of a one-way route city. The banner and the
// StickySearchWidget (which reserves layout space for the banner) key off
// this, so they stay in sync — otherwise a visitor out of range would leave
// a phantom gap for a banner that never renders.
export const useShowOneWayBanner = (): boolean => {
  const { data: geoData } = useGeoDataMyIp();

  return isNearOneWayCity(geoData?.lat, geoData?.lng);
};
